// import { generateClient } from '@aws-amplify/api';
import { type GraphQLResult } from './apiClient';
import { DeviceListResponse } from '../types/device';
// import { Amplify } from 'aws-amplify';
// import { apiConfig } from '../amplify/api/resource';
// import { authConfig } from '../amplify/auth/resource';
import { getApiClient } from './apiClient';

// // Singleton pattern for API client
// let _client: ReturnType<typeof generateClient> | null = null;

// const getClient = () => {
//   if (!_client) {
//   // Ensure Amplify is configured before any client generation
//     Amplify.configure({
//       Auth: authConfig,
//       API: {
//         GraphQL: {
//           ...apiConfig.GraphQL,
//           defaultAuthMode: 'userPool'
//         }
//       }
//     });
//     // // Log current Amplify configuration state
//     // const currentConfig = Amplify.getConfig();
//     _client = generateClient();
//   }
//   return _client;
// };

const getDevicesQuery = /* GraphQL */ `
  query GetDevices($limit: Int, $offset: Int, $keyword: String, $type: Int!, $exactSearch: Boolean) {
    getDeviceList(limit: $limit, offset: $offset, keyword: $keyword, type: $type, exactSearch: $exactSearch) {
      devices {
        id
        brand
        model
        release
        imei
        buildIncremental
        buildDisplayId
        fingerprint
        securityPath
        status
        baseband
        bootloader
        board
        hardware
        manufacturer
        code
        platform
        product
        sdk
        buildHost
        buildId
        buildDescription
        buildDateUtc
        buildFlavor
        custom_note
        mac_address
        safety_net
        gpu
        name
        country
      }
      total
    }
  }
`;

const importDevicesMutation = /* GraphQL */ `
  mutation ImportDevices($devices: [DeviceInput]!, $type: Int!) {
    importDevice(devices: $devices, type: $type) {
      result
      message
    }
  }
`;

const deleteDevicesMutation = /* GraphQL */ `
  mutation DeleteDevices($ids: [String]!, $type: Int!) {
    removeDevice(ids: $ids, type: $type) {
      result
      message
    }
  }
`;

const updateDeviceMutation = /* GraphQL */ `
  mutation UpdateDevice($type: Int!, $index: String!, $device: DeviceInput!) {
    updateDevice(type: $type, index: $index, device: $device) {
      result
      message
    }
  }
`;

interface GetDevicesQueryResponse {
  getDeviceList: DeviceListResponse;
}

interface ImportDevicesResponse {
  importDevice: {
    result: boolean;
    message: string;
  };
}

interface DeleteDevicesResponse {
  removeDevice: {
    result: boolean;
    message: string;
  };
}

interface UpdateDeviceResponse {
  updateDevice: {
    result: boolean;
    message: string;
  };
}

export const deviceService = {
  async getDevices(params: { limit: number; page: number; searchTerm?: string; exactSearch?: boolean }) {
    try {
      const response = await getApiClient().graphql({
        query: getDevicesQuery,
        variables: {
          limit: params.limit,
          offset: params.page * params.limit,
          keyword: params.searchTerm || '',
          type: 1, // Default to type 1 for regular devices
          exactSearch: params.exactSearch || false
        }
      }) as GraphQLResult<GetDevicesQueryResponse>;

      if (response.errors) {
        throw new Error(response.errors.map(e => e.message).join(', '));
      }

      if (!response.data) throw new Error('No data returned');
      return response.data.getDeviceList;
    } catch (error) {
      console.error('Error in getDevices:', error);
      throw error;
    }
  },

  async importDevices(devices: any[], type: number = 1) {
    try {
      const response = await getApiClient().graphql({
        query: importDevicesMutation,
        variables: {
          devices,
          type
        }
      }) as GraphQLResult<ImportDevicesResponse>;

      if (response.errors) {
        throw new Error(response.errors.map(e => e.message).join(', '));
      }

      if (!response.data) throw new Error('No data returned');
      return response.data.importDevice;
    } catch (error) {
      console.error('Error in importDevices:', error);
      throw error;
    }
  },

  async deleteDevices(ids: string[], type: number = 1) {
    try {
      const response = await getApiClient().graphql({
        query: deleteDevicesMutation,
        variables: {
          ids,
          type
        }
      }) as GraphQLResult<DeleteDevicesResponse>;

      if (response.errors) {
        throw new Error(response.errors.map(e => e.message).join(', '));
      }

      if (!response.data) throw new Error('No data returned');
      return response.data.removeDevice;
    } catch (error) {
      console.error('Error in deleteDevices:', error);
      throw error;
    }
  },

  async updateDevice(deviceId: string, deviceData: any, type: number = 1) {
    try {
      const response = await getApiClient().graphql({
        query: updateDeviceMutation,
        variables: {
          type,
          index: deviceId,
          device: deviceData
        }
      }) as GraphQLResult<UpdateDeviceResponse>;

      if (response.errors) {
        throw new Error(response.errors.map(e => e.message).join(', '));
      }

      if (!response.data) throw new Error('No data returned');
      return response.data.updateDevice;
    } catch (error) {
      console.error('Error in updateDevice:', error);
      throw error;
    }
  }
};